export const metersToPixels = (meters) => (meters * 10);
